import React, { useState } from "react"
import { X } from "lucide-react"

const FloatingWidgets: React.FC = () => {
  const [showZalo, setShowZalo] = useState(false)
  const [showDelivery, setShowDelivery] = useState(true)

  return (
    <>
      {/* Zalo + Facebook — bên trái */}
      <div className="fixed bottom-24 left-4 flex flex-col gap-4 z-50">
        <button
          onClick={() => setShowZalo(true)}
          className="w-12 h-12 bg-[#0068FF] rounded-full flex items-center justify-center shadow-lg hover:-translate-y-1 hover:shadow-xl transition-all duration-300 group"
          title="Mở Zalo QR"
        >
          <span className="text-white font-bold text-lg tracking-tight">
            Zalo
          </span>
        </button>
        <a
          href="https://www.facebook.com/nhahangchaythientruc"
          target="_blank"
          rel="noreferrer"
          className="w-12 h-12 bg-[#1877F2] rounded-full flex items-center justify-center shadow-lg hover:-translate-y-1 hover:shadow-xl transition-all duration-300"
        >
          <svg viewBox="0 0 24 24" className="w-8 h-8 text-white" fill="currentColor">
            <path d="M13.397,20.997v-8.196h2.765l0.411-3.209h-3.176V7.548c0-0.926,0.258-1.56,1.587-1.56h1.684V3.127 C15.849,3.039,15.025,2.997,14.201,3c-2.444,0-4.122,1.492-4.122,4.231v2.355H7.332v3.209h2.753v8.202H13.397z" />
          </svg>
        </a>
      </div>

      {/* Shopee, Grab, Be — bên phải */}
      {showDelivery && (
        <div className="fixed bottom-24 right-4 flex flex-col gap-4 z-50">
          <button
            onClick={() => setShowDelivery(false)}
            className="w-5 h-5 bg-white/80 hover:bg-white rounded-full flex items-center justify-center shadow-md self-end transition-colors"
            title="Ẩn"
          >
            <X size={11} className="text-gray-500" />
          </button>
          <a
            href="https://shopeefood.vn/ho-chi-minh/am-thuc-chay-thien-truc-duong-so-3"
            target="_blank"
            rel="noreferrer"
            className="w-12 h-12 flex items-center justify-center hover:-translate-y-1 transition-all duration-300 drop-shadow-md hover:drop-shadow-lg"
          >
            <img
              src="/icons/W-SPF.png"
              alt="Shopee"
              className="w-full h-full object-contain scale-[1.15] animate-shake origin-center"
            />
          </a>
          <a
            href="https://r.grab.com/g/6-20260416_150821_C26CEFCF10484E38B93C5F4FCBD0984E_MEXMPS-5-C6UFAYNCEFNJUA"
            target="_blank"
            rel="noreferrer"
            className="w-12 h-12 flex items-center justify-center hover:-translate-y-1 transition-all duration-300 drop-shadow-md hover:drop-shadow-lg"
          >
            <img
              src="/icons/W-GRAB.png"
              alt="Grab"
              className="w-full h-full object-contain scale-[1.15] animate-shake origin-center"
            />
          </a>
          <a
            href="https://food.be.com.vn/resto?id=99547&name=Ẩm+Thực+Chay+Thiền+Trúc+-Trần+Nhật+Duật"
            target="_blank"
            rel="noreferrer"
            className="w-12 h-12 flex items-center justify-center hover:-translate-y-1 transition-all duration-300 drop-shadow-md hover:drop-shadow-lg"
          >
            <img
              src="/icons/W-BEFOOD.png"
              alt="Be"
              className="w-full h-full object-contain scale-[1.15] animate-shake origin-center"
            />
          </a>
        </div>
      )}

      {/* Popup Zalo QR */}
      {showZalo && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4 animate-in fade-in duration-300">
          <div className="relative w-full max-w-2xl bg-white rounded-2xl overflow-hidden shadow-2xl animate-in zoom-in-95 duration-300">
            <button
              onClick={() => setShowZalo(false)}
              className="absolute top-3 right-3 p-2 bg-white/80 hover:bg-white rounded-full text-gray-800 shadow-md transition-colors z-10"
            >
              <X size={20} />
            </button>
            <div className="px-6 pt-6 pb-2 text-center">
              <h3 className="text-xl font-bold text-[#0068FF]">Kết nối Zalo</h3>
              <p className="text-gray-500 text-sm mt-1">
                Quét mã QR để nhắn tin cho chúng tôi
              </p>
            </div>
            <div className="grid grid-cols-2 gap-6 p-8">
              <div className="flex flex-col items-center gap-2">
                <img
                  src="/icons/W-ZALO-Q1.jpg"
                  alt="Zalo QR Quận 1"
                  className="w-full h-auto rounded-xl shadow-md"
                />
                <span className="text-[#0068FF] font-semibold text-sm">Chi nhánh Quận 1</span>
              </div>
              <div className="flex flex-col items-center gap-2">
                <img
                  src="/icons/W-ZALO.jpg"
                  alt="Zalo QR Thủ Đức"
                  className="w-full h-auto rounded-xl shadow-md"
                />
                <span className="text-[#0068FF] font-semibold text-sm">Chi nhánh Thủ Đức</span>
              </div>
            </div>
          </div>
          <div
            className="absolute inset-0 -z-10"
            onClick={() => setShowZalo(false)}
          />
        </div>
      )}
    </>
  )
}

export default FloatingWidgets
